import { neftApi } from "app/config";

import { removeEmptyValue } from "utils";
import { ApiTableResponse, TransactionDTO } from "models";
import { IApprovalRequestParams } from "./models";

// type NotificationType = "success" | "info" | "warning" | "error";

const requestHistoryApiWithTag = neftApi.enhanceEndpoints({
  addTagTypes: ["transaction-batch"],
});

const requestHistoryApiSlice = requestHistoryApiWithTag.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getApprovalRequest: builder.query<ApiTableResponse<TransactionDTO>, IApprovalRequestParams>({
      query: (approvalRequestParams) => ({
        url: `/approvals`,
        method: "GET",
        params: removeEmptyValue(approvalRequestParams),
      }),
      providesTags: [{ type: "transaction-batch" as const }],
    }),
  }),
});

export const { useGetApprovalRequestQuery, useLazyGetApprovalRequestQuery } =
  requestHistoryApiSlice;

export default requestHistoryApiSlice;
